import axios from 'axios'

export default axios.create({
    baseURL: 'https://proxy-1-w4843165.deta.app/',
    //baseURL: 'http://127.0.0.1:5000',
})
